import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ toggleSidebar }) => {
    const navigate = useNavigate();
    const { currentTenant, user, role, isImplicitAdmin, logout } = useAuth();
    const [showProfileMenu, setShowProfileMenu] = useState(false);

    const tenantName = currentTenant?.name?.trim();
    const tenantInitials = tenantName
        ? tenantName
              .split(' ')
              .filter(Boolean)
              .map((word) => word[0])
              .join('')
              .slice(0, 2)
              .toUpperCase()
        : 'GE';

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const userName = user?.name || '-';
    const profileLabel = isImplicitAdmin ? 'Administrador' : (role?.name || '-');
    const userInitial = (userName || 'U').trim().slice(0, 1).toUpperCase();

    return (
        <header className="bg-gray-900 h-16 fixed top-0 left-0 right-0 z-30 shadow-sm">
            <div className="h-full px-4 md:px-6 flex items-center justify-between">
                {/* Left side: Hamburger (mobile) + Logo (desktop) */}
                <div className="flex items-center gap-4">
                    {/* Hamburger menu - visible only on mobile */}
                    <button
                        onClick={toggleSidebar}
                        className="md:hidden p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
                        aria-label="Toggle menu"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>

                    {/* Logo e Nome - hidden on mobile, visible on desktop */}
                    <div className="hidden md:flex items-center gap-3">
                        <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
                            <span className="text-white font-bold text-xl">
                                {tenantInitials}
                            </span>
                        </div>
                        <div>
                            <h1 className="text-xl font-bold text-white">{tenantName || 'Carregando...'}</h1>
                            <p className="text-xs text-gray-400">Gestão Empresarial</p>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="flex items-center gap-2 md:gap-4">
                    {/* Perfil */}
                    <div className="relative pl-2 md:pl-4 border-l border-white/20">
                        <button
                            className="flex items-center gap-2 md:gap-3 hover:opacity-80 transition-opacity"
                            onClick={() => setShowProfileMenu(!showProfileMenu)}
                        >
                            <div className="text-right hidden md:block">
                                <p className="text-sm font-medium text-white">{userName}</p>
                                <p className="text-xs text-primary-100">{profileLabel}</p>
                            </div>
                            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                                <span className="text-white font-semibold text-sm">{userInitial}</span>
                            </div>
                        </button>

                        {/* Menu Dropdown */}
                        {showProfileMenu && (
                            <>
                                <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setShowProfileMenu(false)}
                                />
                                <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                                    <button
                                        onClick={handleLogout}
                                        className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                        </svg>
                                        Sair
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;

